import { render, staticRenderFns } from "./ExpandedMachineCard.vue?vue&type=template&id=6720cc0e&scoped=true&"
import script from "./ExpandedMachineCard.vue?vue&type=script&lang=js&"
export * from "./ExpandedMachineCard.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedMachineCard.vue?vue&type=style&index=0&id=6720cc0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6720cc0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDivider,VRow})
